// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentFailed_container__2_GIJ","header":"PaymentFailed_header__27i6-","crossmark":"PaymentFailed_crossmark__WeLIx"};